import UserStore from "../app/stores/userStore";
import i18n from "./i18n";

export async function initializeUserAndLanguageSettings(userStore: UserStore) {
  try {
    if (userStore.token) {
      // Wait for user data to load before proceeding
      await userStore.getUser();
    }

    // Load preferred language from localStorage
    const lang = localStorage.getItem("language");

    if (lang === "ar") {
      i18n.changeLanguage("ar");
      userStore.setLanguage("ar");
      document.documentElement.setAttribute("lang", "ar");
      document.documentElement.setAttribute("dir", "rtl");
    } else {
      i18n.changeLanguage("en");
      userStore.setLanguage("en");
      document.documentElement.setAttribute("lang", "en");
      document.documentElement.setAttribute("dir", "ltr");
    }
  } catch (error) {
    console.error("Error initializing user or language settings:", error);
  } finally {
    // App is ready only after all setup
    userStore.setAppLoaded();
  }
}
